import CrudActionSetBase from './CrudActionSetBase'

export class TagActionSet extends CrudActionSetBase('tag'){}
export default new TagActionSet()